<div class="main-content" *ngIf="finance != null">
  <!--      WaitingPayment = 1,
            StorePaid = 2,
            PartiallyDonated = 3,
            Donated = 4,
            WaitingNgoInfo = 5,
            Completed = 10,
            NotPaid = 11,
            WithProblem = 20 -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart" style="background: #b8d8d8;">
          <div class="card-header text-center">
            <h5 class="card-title">Pendente</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'1'"></card-pipepolen>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart" style="background: #d5e5a3;">
          <div class="card-header text-center">
            <h5 class="card-title">Pago</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'2'"></card-pipepolen>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart" style="background:  #ff8f5e;">
          <div class="card-header text-center">
            <h5 class="card-title">Doação Feita</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'3,4'"></card-pipepolen>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart" style="background:#d6c1ab">
          <div class="card-header text-center">
            <h5 class="card-title">Aguardando Dados da Ong</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'5'"></card-pipepolen>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart" style="background: #d5e5a3;">
          <div class="card-header text-center">
            <h5 class="card-title">Completo!</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'10'"></card-pipepolen>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-sm-6">
        <div class="card card-circle-chart"  style="background:  #ff8f5e;">
          <div class="card-header text-center">
            <h5 class="card-title">Não Pagou</h5>
          </div>
          <div class="card-content">
              <card-pipepolen [invoices]="finance.statements" [status]="'11'"></card-pipepolen>
          </div>
        </div>
        <div class="card card-circle-chart"  style="background:  #ff8f5e;">
            <div class="card-header text-center">
              <h5 class="card-title">Com Problemas</h5>
            </div>
            <div class="card-content">
                <card-pipepolen [invoices]="finance.statements" [status]="'20'"></card-pipepolen>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>